'use client';

import React from 'react';
import ContentGrid from '../Grids/ContentGrid/ContentGrid';
import { cm } from 'src/utils/classNames';
import { WithChildren, WithClassName } from 'src/utils/UtilityTypes';

interface Props extends WithChildren, WithClassName {
	maxWidth?: number;
	childrenWrapperClassName?: string;
}

export default function PageContentWrapper({
	maxWidth,
	className,
	children,
	childrenWrapperClassName,
}: Props) {
	return (
		<ContentGrid
			cols={12}
			maxWidth={maxWidth ?? 1080}
			className={cm('px-sm sm:px-lg', className)}
		>
			<ContentGrid.ResponsiveCell
				sizeConfig={{ xs: 12 }}
				className={childrenWrapperClassName}
			>
				{children}
			</ContentGrid.ResponsiveCell>
		</ContentGrid>
	);
}
